import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";

export const styles = ({spacing, palette}: Theme) => createStyles({
    container: {
        width: "100%",
        padding: spacing.unit * 5,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        boxSizing: "border-box",
        position: "relative",
        zIndex: 0,
        "&::before": {
            position: "absolute",
            content: `""`,
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.38)",
        }
    },
    content: {
        position: "relative",
        maxWidth: 1024,
        marginLeft: "auto",
        marginRight: "auto",
        color: palette.primary.contrastText,
        "& p + h3": {
            marginTop: spacing.unit * 2,
        }
    },
    details: {
        maxWidth: "16em"
    },
    title: {
        marginBottom: spacing.unit * 4
    },
    button: {
        position: "absolute",
        top: "50%",
        right: 0,
        transform: "translate(0%, -50%)",
        width: spacing.unit * 16,
        height: spacing.unit * 16,
        background: palette.secondary.dark,
        borderRadius: 0,
        "&:hover": {
            background: palette.secondary.dark,
        },
        "& > span:first-child": {
            display: "flex",
            flexDirection: "column"
        }
    },
    buttonLabel: {
        marginTop: spacing.unit,
        textTransform: "initial",
        color: palette.primary.contrastText,
        fontWeight: 200,
    }

});


// WEBPACK FOOTER //
// ./src/components/Cover/Cover.style.tsx